import { chakra } from '@chakra-ui/react';

import { chipRecipe } from '../../theme/recipes/chip';

/**
 * Чип: факт, статус или число поверх обложки. Правила и причины — в самом рецепте
 * (`theme/recipes/chip.ts`); здесь только привязка рецепта к элементу.
 *
 * `span`, а не `div`: чип почти всегда стоит внутри строки текста или рядом с ней, и блочный
 * элемент ломал бы поток в тех местах, где он идёт после названия игры или ника.
 */
export const Chip = chakra('span', chipRecipe);
